import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { AppUtilService } from '../utils/app-util.service';
import { CacheConstant } from '../constants/app.constant';
import { OrderRoutes } from '../constants/routes.constant';
import { RouteService } from '../services/route.service';

@Injectable()
export class CanReviewOrderGuard implements CanActivate {
  /***************Properties***************/
  private validSenderUrls = [
    OrderRoutes.ShoppingCart,
    OrderRoutes.PaymentOptions
  ];
  /***************Properties***************/

  /***************Constructor***************/
  constructor(private routeService: RouteService) {}
  /***************Constructor***************/

  /******************Implementation Methods******************/

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const reviewOrder = AppUtilService.cache.get(CacheConstant.Order_Review);
    const isAuthenticated = AppUtilService.cache.get(CacheConstant.Okta_Authenticated);

    if (reviewOrder && this.isValidSender()) {
      return true;
    }

    if (isAuthenticated) {
      AppUtilService.router.navigate([OrderRoutes.ShoppingCart]);
    }
    AppUtilService.cache.remove(CacheConstant.Payment_Method);
    return false;
  }

  /******************Implementation Methods******************/

  /******************Private Methods******************/

  private isValidSender(): boolean {
    let validSender = false;
    let previousUrl = this.routeService.getPreviousUrl();
    previousUrl = previousUrl ? previousUrl.substring(1) : null;

    if (previousUrl) {
      validSender =
        this.validSenderUrls.find(url => previousUrl.indexOf(url) > -1) !==
        undefined;
    }

    return validSender;
  }

  /******************Private Methods******************/
}
